export default __webpack_public_path__ + "static/media/0x2e2dde47952b9c7defde7424d00dd2341ad927ca.83c6d861.png";